import React, { useMemo } from 'react';

import GoalToIds from 'components/MeshList/goals/GoalToIds';
import { ListIemUpdatingCSS, ListItemCSS } from 'components/MeshList/styles';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FlexContainer, StyledTooltip } from 'styles/common';

import { getPageName } from 'constants/helper';

import { getColorFromGoalProgressLevel, getGoalProgress } from 'services/helpers/goal';

import { Typography4 } from 'uiToolkit/Typography';

export default function GoalListItem({ goal, onClickHandler, style }) {
  const location = useLocation();

  const pageName = useMemo(() => getPageName(location), [location.pathname]);

  const progressText = getGoalProgress({
    defaultDisplayValue: 0,
    startValue: goal.startingProgressValue,
    achievedValue: goal.actual,
    targetValue: goal.target,
  });

  const color = getColorFromGoalProgressLevel(goal.goalProgressLevel) || 'textSecondary';

  return (
    <Container isUpdating={goal.isUpdating} onClickCapture={onClickHandler} style={style}>
      <FirstRow>
        <StyledTooltip title={goal.text}>
          <div style={{ width: '130px' }}>
            <Typography4 truncate>{goal.text}</Typography4>
          </div>
        </StyledTooltip>
        {/* <TaskOrGoalName
          text={goal.text}
          macros={goal.macros}
          isCompleted={goal.status === 'COMPLETED'}
        /> */}
        <FlexContainer style={{ justifyContent: 'flex-end' }}>
          <GoalToIds
            pageName={pageName}
            //   dispatch={dispatch}
            goalId={goal.id}
            goalKey={goal.key}
            employees={goal.toIds}
            padding="0"
            maxNodes={3}
            iconSize="fixed24px"
            renderEmptyView={(props) => null}
          />
          <Typography4 customColor={color} leftGutter={2} align="right" style={{ width: '32px' }}>
            {progressText ?? '-'}%
          </Typography4>
        </FlexContainer>
      </FirstRow>

      {/* <div onClick={e => e.stopPropagation()}>
        <StyledGoalProgressSlider
          onChange={newValue => {
            dispatch(
              updateGoalProgressAction({
                id: goal.id,
                key: goal.key,
                goalProgressValue: newValue
              })
            );
          }}
          onChangeCommitted={newValue => {
            sendGoalEvent({
              page: { pageName, flow: 'Activity' },
              eventName: GOAL_EVENTS.UpdatedProgressBar,
              field: 'goalProgressValue',
              referrer: [
                routesForTracking.home.pageName,
                routesForTracking.profile.pageName
              ].includes(pageName)
                ? 'MeshList'
                : 'Card'
            });
            dispatch(
              updateGoalProgressOnServerAction({
                id: goal.id,
                key: goal.key,
                goalProgressValue: newValue
              })
            );
          }}
          targetValue={goal.target}
          initialValue={goal.startingProgressValue}
          unit={goal.measure}
          progressLevel={goal.goalProgressLevel}
          achieved={goal.actual}
        />
      </div> */}
    </Container>
  );
}

const FirstRow = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  justify-content: space-between;
`;

const SecondRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 10px;
  align-items: center;
`;

const Container = styled.div`
  position: relative;
  ${ListItemCSS};
  ${ListIemUpdatingCSS};
  padding: 6px 24px;
  cursor: pointer;

  &:hover {
    z-index: 100;
    ${
      '' /* box-shadow: 0 1px 2px 0 ${props => props.theme.palette.shadows.card},
      0 2px 6px 2px ${props => props.theme.palette.shadows.card}; */
    }
    background-color: ${(props) => props.theme.palette.background.blue.light.v2};
  }
`;
